import React, { Component } from 'react'
import { observer } from 'mobx-react'
import t from '../../service/translate.service'
import PropTypes from 'prop-types'
import BasicSlider from '../../components/BasicSlider'
import { MenuArrowIcon } from '../../components/icons'
import PrimaryTitle from '../../components/PrimaryTitle'
import Categories from './Categories'
import BenefitList from './BenefitList'
import { extendObservable } from 'mobx'
import { getAll } from '../../store/offer.store'
import { api } from '../../service/api.service'
import { Link } from 'react-router-dom'
import withRouter from '../../components/withRouter'
import historyService from '../../service/history.service'
import DOMPurify from 'dompurify'
import LoadingPageOverlay from '../../components/LoadingPageOverlay'

class Benefits extends Component {
  constructor (props) {
    super(props)
    extendObservable(this, {
      offers: [],
      categories: [],
      partners: [],
      isLoading: false,
      total: 0,
      lastFetchSkip: 0,
      selectedCategory: { id: 0, name: 'All', nameDe: 'Alle' },
      toggleHowItWorks: false
    })
  }

  componentDidMount = () => {
    (async() => {
      window.scrollTo(0, 0)
      this.isLoading = true
      await this.getAllOffers()
      await this.getCategories()
      await this.getPartners()
      this.isLoading = false
    })()
  }

  getAllOffers = async (skip = 0, limit = 10) => {
    await getAll(skip, limit)
      .then(({ offers, total }) => {
        const remapedOffers = offers.map(o => {
          var offer = {}
          offer.id = o.id
          offer.image = 'https://www.grandcityproperty.de' + o.image.thumbnails['news-overview-image']
          offer.title = o.headline
          offer.description = o.text
          return offer
        })
        const updatedOffers = this.offers.concat(remapedOffers)
        this.offers = updatedOffers
        this.total = total

        // USE THIS IF ALL OFFERS NEED TO BE FETCHED
        /*
        if (this.total > this.offers.length) {
          this.lastFetchSkip = this.lastFetchSkip + remapedOffers.length
          this.getAllOffers(this.lastFetchSkip, 10)
        }
        */
        //this.isLoading = false
      })
      .catch(() => {
        //this.isLoading = false
      })
  }

  getCategories = async () => {
    await api.get(`/partner-categories?includePartners=true`)
      .then(res => {
        const filteredCategories = res.data.rows.filter(
          category => category.partners.length > 0
        )
        this.categories = [this.selectedCategory, ...filteredCategories]
        this.selectedCategory = this.categories[0]
      })
  }

  getPartners = async () => {
    await api.get(`/partner`).then(res => {
      this.partners = res.data.rows
    })
  }

  handleClick = (id) => {
    this.props.navigate('/offer/' + id)
  }

  handleCategoryClick = (e, category) => {
    if (e.key !== 'Tab') {
      e.preventDefault()
    }
    this.selectedCategory = category
  }

  handleToggleHowItWorks = (e) => {
    if (e.key !== 'Tab') {
      e.preventDefault()
    }
    this.toggleHowItWorks = !this.toggleHowItWorks
  }
  async openLink (e, link) {
    e.preventDefault()
    if (link === '/links/mivo') {
      const res = await api.get(`/links/mivo`)
      link = DOMPurify(res.data.url)
    }
    window.open(link, '_blank')
  }
  render () {
    const expandedClass = this.toggleHowItWorks ? '' : 'expanded'
    return (
      <div>
        {this.isLoading && <LoadingPageOverlay />}
        <PrimaryTitle title={t.BENEFITS} />
        <div className={`how-it-works ${expandedClass}`}>
          <a
            href=''
            className='header'
            style={{ textDecoration: 'none' }}
            onClick={(e) => {
              this.handleToggleHowItWorks(e)
            }}
            aria-expanded={expandedClass ? 'true' : 'false'}
            aria-controls="how-it-works-description"
          >
            <div className='title secondary'>{t.BENEFITS_SUBTITLE}</div>
            {MenuArrowIcon}
          </a>
          <div id="how-it-works-description" className='description'>{t.BENEFITS_TEXT}</div>
        </div>
        <Categories
          categories={this.categories}
          selectedCategoryId={this.selectedCategory.id}
          handleClick={this.handleCategoryClick}
        />
        {this.selectedCategory.id === 0 ? (
          <div>
            <BenefitList items={this.partners.slice(0, 3)} openLink={this.openLink} />
            <div className='text-center'>
              <div className='title secondary max'>{t.BENEFITS_OFFERS_TITLE}</div>
              <BasicSlider 
                items={this.offers} 
                handleClick={this.handleClick} 
                settings={{
                  dots: true,
                  infinite: true,
                  speed: 500,
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  className: 'slider variable-width',
                  centerMode: true,
                  centerPadding: '0px',
                  variableWidth: true
                }} 
              />
            </div>
            <div className='text-center' style={{ marginTop: '100px' }}>
              <Link 
                className='button tertiary' 
                to='/offers' 
                onClick={() => { historyService.push('/offers') }}
                aria-label={t.BENEFITS_VOUCHERS_LINK}
              >
                {t.BENEFITS_VOUCHERS_LINK}
              </Link>
            </div>
            <div className='other-benefits'>
              <div className='title secondary max'>{t.BENEFITS_OTHER_TITLE}</div>
              <BenefitList items={this.partners.slice(3)} openLink={this.openLink} />
            </div>
          </div>
        ) : (
          <BenefitList items={this.selectedCategory.partners} openLink={this.openLink} />
        )}
      </div>
    )
  }
}

export default withRouter(observer(Benefits))
